import React from 'react';
import {
  FaChevronDown
} from 'react-icons/fa';

function Header() {
  const username = 'John Doe';

  return (
    <div>
      {/* Header */}
      <header className="bg-[#7ABC32] h-28 py-2 px-[20%] flex items-center justify-between relative">
        
        {/* Logo Section */}
        <img
          src="/assets/images/EI-logo.png"
          alt="Logo"
          className="w-[18%] md:w-[18%] lg:w-42 h-auto"
        />

        {/* Right Section: Username and Dropdown */}
        <div className="flex items-center space-x-2 text-black">
          <span className="font-medium">{username}</span>
          <FaChevronDown
            size={16}
            className="hover:scale-110 transition cursor-pointer"
          />
        </div>
      </header>
    </div>
  );
}

export default Header;
